<template>
  <div>
    <a
      v-bind="$attrs"
      v-if="to"
      tag="a"
      :href="to"
      v-bind:class="buttonClasses"
      class="w-full md:w-auto"
      >{{ renderedButtonText }}</a
    >
    <button
      v-if="click"
      v-bind="$attrs"
      v-bind:class="buttonClasses"
      class="w-full md:w-auto"
      @click.prevent="runClick"
      @submit.prevent
      :disabled="disabledState"
    >
      {{ renderedButtonText }}
    </button>
  </div>
</template>
<script>
export default {
  name: "Button",
  props: {
    to: {
      type: [Object, String],
      default: undefined,
    },
    click: {
      type: Function,
      default: undefined,
    },
    type: {
      type: String,
      default: "default",
    },
    buttonText: {
      type: String,
      required: true,
    },
    confirm: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      default: "Are you sure?",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultButtonClasses: "border shadow transition-colors duration-100 border-gray-600 bg-white hover:bg-red-400 hover:border-red-400 active:from-white active:to-white text-gray-800 active:text-red-700 font-bold px-6 py-1 rounded-md leading-8 tracking-wide",
      primaryButtonClasses:
        "border shadow transition-colors duration-100 border-red-600 bg-red-600 hover:bg-red-400 hover:border-red-400 active:from-white active:to-white text-white active:text-red-700 font-bold px-6 py-1 rounded-md leading-8 tracking-wide",
      disabledPrimaryButtonClasses:
        "border shadow border-red-50 bg-red-50 text-red-400 active:text-red-700 font-bold px-6 py-1 rounded-md leading-8 tracking-wide",
      largePrimaryButtonClasses:
        "w-full border shadow border-red-600 bg-red-600 active:from-white active:to-white text-white active:text-red-700 font-bold px-6 py-1 rounded-md leading-8 tracking-wide",
      disabledLargePrimaryButtonClasses:
        "w-full border shadow border-red-500 bg-white text-red-500 font-bold px-6 py-1 rounded-md leading-8 tracking-wide",
      secondaryDangerButtonClasses: "text-red-800 underline px-6 py-1",
      state: "active",
    };
  },
  computed: {
    buttonClasses() {
      switch (this.type) {
        case "primary":
          return this.state === "active"
            ? this.primaryButtonClasses
            : this.disabledPrimaryButtonClasses;
        case "primary-large":
          return this.state === "active"
            ? this.largePrimaryButtonClasses
            : this.disabledLargePrimaryButtonClasses;
        case "danger":
          return this.secondaryDangerButtonClasses;
        case "default":
        default:
          return this.defaultButtonClasses;
      }
    },
    renderedButtonText() {
      return this.buttonText;
    },
    disabledState() {
      return this.state === "disabled";
    },
  },
  methods: {
    async runClick(e) {
      if (this.confirm === true) {
        if (window.confirm(this.confirmText)) {
          this.state = "disabled";
          await this.click(e);
          this.state = "active";
        }
      } else {
        this.state = "disabled";
        await this.click(e);
        this.state = "active";
      }
    },
  },
};
</script>
